"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _tracking = require("settings-ui-app/utils/tracking");

var _AdsContainer = _interopRequireDefault(require("./containers/AdsContainer"));

var _AsyncContainers = require("./AsyncContainers");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: "" + _UrlPathParams.ADS,
  component: _AdsContainer.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: "adAccounts"
}), _react.default.createElement(_reactRouter.Route, {
  path: "adAccounts",
  component: _AsyncContainers.AsyncAdAccountTableContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('accounts')
}), _react.default.createElement(_reactRouter.Route, {
  path: "leadSyncing",
  component: _AsyncContainers.AsyncAdsLeadSyncingTableContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('leadSyncing')
}), _react.default.createElement(_reactRouter.Route, {
  path: "pixels",
  component: _AsyncContainers.AsyncAdsPixelTableContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('pixels')
}), _react.default.createElement(_reactRouter.Route, {
  path: "roiCalculation",
  component: _AsyncContainers.AsyncAdsROICalculationContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('roiCalculation')
}));

exports.default = _default;
module.exports = exports.default;